module.exports = __webpack_public_path__ + "assets/img/icon-sucessfully.8a29a3b2.svg";